import type { QueryClient } from '@tanstack/react-query';

/**
 * The three query keys an identity write invalidates — in ONE place, because
 * there are now two callers.
 *
 * FD-513 found the manual save and the CSV import invalidating different sets:
 * the import missed `['identity-mappings', migrationId]`, which is exactly the
 * query an import writes to, so the queue kept rendering pre-import mappings
 * until something else happened to refetch. The comment beside it claimed
 * parity, which is what made the omission invisible to review.
 *
 * Moving the CSV controls into the campaign `···` menu adds a THIRD write site
 * (`MigrationLayout`), so the set stops being something two components each
 * remember and becomes something one function states.
 */
export function invalidateIdentityQueries(queryClient: QueryClient, migrationId: string) {
  queryClient.invalidateQueries({ queryKey: ['identity-suggestions', migrationId] });
  queryClient.invalidateQueries({ queryKey: ['migration', migrationId] });
  queryClient.invalidateQueries({ queryKey: ['identity-mappings', migrationId] });
}
